import { useEffect, useState } from 'react';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { getStringSafe } from 'services/Eppo';
import { getAbTestName } from 'services/Analytics/helpers';
import { Provider } from 'services/Analytics/core';

import { IInstallAppSteps } from './types';

import InstallAppStepsDefault from './InstallAppStepsDefault';
import InstallAppStepsA from './InstallAppStepsA';

const InstallAppSteps = (props: IInstallAppSteps) => {
    const [variant, setVariant] = useState<string | undefined>();

    useEffect(() => {
        const e = getStringSafe({
            flag: ONGOING_EXPERIMENTS.DownloadPageRedesign,
            def: 'Default',
        });

        setVariant(e);

        Provider.provideData({
            abTestName: async () =>
                getAbTestName({
                    experiment: ONGOING_EXPERIMENTS.DownloadPageRedesign,
                    variantName: e,
                }),
        });

        return () => {
            Provider.provideData({ abTestName: async () => null });
        };
    }, []);

    switch (variant) {
        case 'a':
            return <InstallAppStepsA {...props} />;

        case 'default':
            return <InstallAppStepsDefault {...props} />;

        default:
            return <InstallAppStepsDefault {...props} />;
    }
};

export default InstallAppSteps;
